import PAYMENT_PROVIDERS, { PAYMENT_MODES, PAYMENT_TYPE } from '../../../constants/PaymentProviders';

// there are already existing "GMO" and "RPay" modules for PG payment,
// in order to not affect PG payment behavior, BE team create a new module 'GMORPay' for RCO.
// GMORPay module uses the same DB field as GMO module for PG payment, and
// the pp_name is 'GMO' for tran_payment, but 'GMORPay' for payment_options in transaction response,
// and BE team cannot manually change 'GMO' to 'GMORPay' for trans_payment in transaction response
// so in RCO, it has to be manually converted.
const enhanceGMOPaymentName = (name: string): string => (name === 'GMO' ? PAYMENT_PROVIDERS.GMORPay : name);

const enhanceCODPaymentName = (
  name: string,
  mode: PAYMENT_MODES,
  type: PAYMENT_TYPE,
): string => (type === PAYMENT_TYPE.COD ? type : name);

const compose = <T>(...functions: (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (first: T, ...rest: any) => T)[]) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    first: T, ...args: any
  ) => functions.reduceRight(
    (result, fn) => fn(result, ...args), first,
  );

export const enhancePaymentName = compose(
  enhanceGMOPaymentName,
  enhanceCODPaymentName,
);
